// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/BrandWatchlist.css */
.main-container {
    display: flex;
    flex-direction: column;
    height: 80vh;
}

.main-header {
    display: flex;
    align-items: center;
}

.logo {
    height: 20vh;
    margin: 15px;
    /* Adjust as needed */
}


.main-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

/* Define the keyframes for the color transition */
/* Define the keyframes for the color transition */
/* Define the keyframes for the color transition */

/* Apply the animation to the h1 element */
.BApp h1 {
    /* font-size: 5rem; */
    /* margin-top: -2em; */
    margin-bottom: 0.5rem;
    font-weight: 500;
}


.BApp h4 {
    margin-top: 0em;
    margin-bottom: 1.5em;
    font-size: 20px;
    font-weight: 500;
}

.BApp .input-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: .5em;
}

.BApp .entries {
    margin-bottom: 1em;
    margin-left: 10px;
}

.BApp .entries {
    display: flex;
    flex-direction: row;
    gap: 15px;
    width: 55vw;
    align-items: start;
    vertical-align: middle;
    height: 4vh;
    font-size: 15px;
    font-weight: 500;
    color: #000000
}

.BApp .entry {
    vertical-align: middle;
    padding: 5px 15px 7px;
    border: 2px solid rgba(11, 11, 11, 0.704);
    border-radius: 15px;
    background: transparent;
}

.BApp .inputs {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 2px solid black;
    border-radius: 15px;
    min-width: 100%;
}

.BApp .inputs input {
    margin: 5px;
    padding: 10px;
    width: 50vw;
    height: 6vh;
    font-size: 20px;
    border: none;
    /* border-bottom: none; */
    outline: none;
    background: transparent;
    /* transition: border-bottom-color 0.3s; */
}

/* input:focus {
    border-bottom: 2px solid #878787;
} */

.BApp .buttons {
    height: 100%;
    margin: 0;

}

.BApp .buttons button {
    /* margin-top: -10px; */
    font-size: 40px;
    font-weight: 500;
    opacity: 40%;
    height: 100%;
    border: none;
    background-color: transparent;
    cursor: pointer;
    vertical-align: middle;

}

.BApp .submit-button {
    border-radius: 16px;
    color: white;
    font-size: 20px;
    margin: 1em;
    /* width: 20vw; */
    height: 7vh;
    box-shadow: none;
    background-color: #c52026;
    border: none;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
}

.risk {
    color: white;
    /* background-color: #c52026; */
    padding: 3px;
    background: url(//s2.svgbox.net/pen-brushes.svg?ic=brush-1&color=c52026);
    margin: -2px 0px;
    padding: 1px 5px;
}

.popup-alert {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #4CAF50;
    color: white;
    padding: 15px;
    border-radius: 5px;
    z-index: 1000;
    opacity: 1;
    transition: opacity 1s ease-out;
}

.popup-alert p {
    margin: 0;
    font-size: 1em;
}

.popup-alert.fade-out {
    opacity: 0;
}

@media (max-width: 740px) {
    .main-container {
        min-height: 60vh;
    }
}

@media (max-width: 540px) {
    .main-container {
        padding-bottom: 4vh;
        padding: 10px;
    }

    h1 {
        margin-top: 10px;
        font-size: 2.5em;
    }

    h4 {
        margin-bottom: 20px;
    }

    .logo {
        height: 7vh;
        margin: 15px 10px;
    }

    .inputs input {
        width: 80vw !important;
        height: 2vh;
    }

    .submit-button {
        width: fit-content;
    }

    .entries {
        width: 90vw;
        margin-bottom: 0px;
    }

}`, "",{"version":3,"sources":["webpack://./src/BA/BrandWatchlist.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD,kDAAkD;AAClD,kDAAkD;;AAElD,0CAA0C;AAC1C;IACI,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;;GAEG;;AAEH;IACI,YAAY;IACZ,SAAS;;AAEb;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;;AAE1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,wEAAwE;IACxE,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;AAEJ","sourcesContent":["/* src/BrandWatchlist.css */\n.main-container {\n    display: flex;\n    flex-direction: column;\n    height: 80vh;\n}\n\n.main-header {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    height: 20vh;\n    margin: 15px;\n    /* Adjust as needed */\n}\n\n\n.main-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n/* Define the keyframes for the color transition */\n/* Define the keyframes for the color transition */\n/* Define the keyframes for the color transition */\n\n/* Apply the animation to the h1 element */\n.BApp h1 {\n    /* font-size: 5rem; */\n    /* margin-top: -2em; */\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n}\n\n\n.BApp h4 {\n    margin-top: 0em;\n    margin-bottom: 1.5em;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.BApp .input-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: .5em;\n}\n\n.BApp .entries {\n    margin-bottom: 1em;\n    margin-left: 10px;\n}\n\n.BApp .entries {\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    width: 55vw;\n    align-items: start;\n    vertical-align: middle;\n    height: 4vh;\n    font-size: 15px;\n    font-weight: 500;\n    color: #000000\n}\n\n.BApp .entry {\n    vertical-align: middle;\n    padding: 5px 15px 7px;\n    border: 2px solid rgba(11, 11, 11, 0.704);\n    border-radius: 15px;\n    background: transparent;\n}\n\n.BApp .inputs {\n    margin-top: 5px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border: 2px solid black;\n    border-radius: 15px;\n    min-width: 100%;\n}\n\n.BApp .inputs input {\n    margin: 5px;\n    padding: 10px;\n    width: 50vw;\n    height: 6vh;\n    font-size: 20px;\n    border: none;\n    /* border-bottom: none; */\n    outline: none;\n    background: transparent;\n    /* transition: border-bottom-color 0.3s; */\n}\n\n/* input:focus {\n    border-bottom: 2px solid #878787;\n} */\n\n.BApp .buttons {\n    height: 100%;\n    margin: 0;\n\n}\n\n.BApp .buttons button {\n    /* margin-top: -10px; */\n    font-size: 40px;\n    font-weight: 500;\n    opacity: 40%;\n    height: 100%;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    vertical-align: middle;\n\n}\n\n.BApp .submit-button {\n    border-radius: 16px;\n    color: white;\n    font-size: 20px;\n    margin: 1em;\n    /* width: 20vw; */\n    height: 7vh;\n    box-shadow: none;\n    background-color: #c52026;\n    border: none;\n    cursor: pointer;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.risk {\n    color: white;\n    /* background-color: #c52026; */\n    padding: 3px;\n    background: url(//s2.svgbox.net/pen-brushes.svg?ic=brush-1&color=c52026);\n    margin: -2px 0px;\n    padding: 1px 5px;\n}\n\n.popup-alert {\n    position: fixed;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #4CAF50;\n    color: white;\n    padding: 15px;\n    border-radius: 5px;\n    z-index: 1000;\n    opacity: 1;\n    transition: opacity 1s ease-out;\n}\n\n.popup-alert p {\n    margin: 0;\n    font-size: 1em;\n}\n\n.popup-alert.fade-out {\n    opacity: 0;\n}\n\n@media (max-width: 740px) {\n    .main-container {\n        min-height: 60vh;\n    }\n}\n\n@media (max-width: 540px) {\n    .main-container {\n        padding-bottom: 4vh;\n        padding: 10px;\n    }\n\n    h1 {\n        margin-top: 10px;\n        font-size: 2.5em;\n    }\n\n    h4 {\n        margin-bottom: 20px;\n    }\n\n    .logo {\n        height: 7vh;\n        margin: 15px 10px;\n    }\n\n    .inputs input {\n        width: 80vw !important;\n        height: 2vh;\n    }\n\n    .submit-button {\n        width: fit-content;\n    }\n\n    .entries {\n        width: 90vw;\n        margin-bottom: 0px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
